import { jsx } from "react/jsx-runtime";
import { useBackgroundLightness } from "../Box/BackgroundContext.mjs";
import { Box } from "../Box/Box.mjs";
import { base, strong, regular, lightModeWeight, darkModeWeight } from "./Divider.css.mjs";
const Divider = ({ weight = "regular" }) => {
  const lightness = useBackgroundLightness();
  return /* @__PURE__ */ jsx(Box, { component: "span", display: "block", position: "relative", width: "full", children: /* @__PURE__ */ jsx(
    Box,
    {
      component: "span",
      position: "absolute",
      left: 0,
      right: 0,
      className: [
        base,
        weight === "strong" ? strong : regular,
        lightModeWeight[lightness.lightMode],
        darkModeWeight[lightness.darkMode]
      ]
    }
  ) });
};
export {
  Divider
};
